<script setup>
import BannerForm from '@frontJs/components/forms/projectManagement/sem/BannerForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, websiteVariants, semBanner } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    websiteVariants: {
        type: Array,
        required: true,
    },
    semBanner: {
        type: [Object, null],
        required: false,
        default: null,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="semBanner">
            Mettre à jour la bannière #{{ semBanner.id }} - SEM - Gestion de
            projet - Datakepler
        </title>

        <title v-else>
            Créer une bannière - SEM - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="semBanner" :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - SEM - Mettre à jour la bannière #{{ semBanner.id }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - SEM - Créer une bannière
    </PageTitle>

    <BannerForm
        :tenant="tenant"
        :website-variants="websiteVariants"
        :sem-banner="semBanner"
    />
</template>
